/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-10-29 16:53:18.

export interface CreateMasterAgentApplicationGroupRequest {
    name: string;
    description: string;
    applicationType: PlatformApplicationTypeEnum;
}

export interface CreateMasterAgentApplicationRequest {
    id: string;
    code3: string;
    name: string;
    description: string;
    active: boolean;
    applicationType: PlatformApplicationTypeEnum;
    status: PlatformApplicationStatusEnum;
    userStatus: PlatformApplicationUserEnum;
    loginType: PlatformApplicationLoginTypeEnum;
    registrationType: PlatformApplicationRegistrationTypeEnum;
    groupId: string;
    secretKey: string;
}

export interface SetMasterAgentApplicationLanguagesRequest {
    id: string;
    languages: string[];
}

export interface UpdateMasterAgentApplicationGroupRequest {
    id: string;
    name: string;
    description: string;
}

export interface UpdateMasterAgentApplicationRequest {
    id: string;
    name: string;
    description: string;
    active: boolean;
    status: PlatformApplicationStatusEnum;
    userStatus: PlatformApplicationUserEnum;
    loginType: PlatformApplicationLoginTypeEnum;
    registrationType: PlatformApplicationRegistrationTypeEnum;
    groupId: string;
    secretKey: string;
}

export interface UpdateMasterAgentApplicationSecretRequest {
    id: string;
    code3: string;
    name: string;
    description: string;
    applicationType: PlatformApplicationTypeEnum;
    status: PlatformApplicationStatusEnum;
    userStatus: PlatformApplicationUserEnum;
    loginType: PlatformApplicationLoginTypeEnum;
    registrationType: PlatformApplicationRegistrationTypeEnum;
    groupId: string;
    secretKey: string;
}

export interface WebStringResponse extends WebResponseEntity<string> {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface CreateCurrencyDto {
    isoName: string;
    localName: string;
    localCode: string;
    isoAlpha3: string;
    isoNumeric: string;
    symbol: string;
    precision: number;
    currencyTypeId: string;
    currencyFormatId: string;
    platformServiceCode: string;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
}

export interface GetFilteredCurrencyPageDto {
    isoName: string;
    localName: string;
    localCode: string;
    isoAlpha3: string;
    isoNumeric: string;
    paginationData: PaginationRequestCommonDto;
    sortBy: string;
    ascending: boolean;
    onlyActive: boolean;
}

export interface SearchRequest extends Serializable {
    filters: FilterRequest[];
    sorts: SortRequest[];
    page: number;
    size: number;
}

export interface UpdateCurrencyDto {
    currencyId: string;
    isoName: string;
    localName: string;
    localCode: string;
    isoAlpha3: string;
    isoNumeric: string;
    symbol: string;
    precision: number;
    currencyTypeId: string;
    currencyFormatId: string;
    userId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
}

export interface CreateCurrencyCountryDto {
    countryId: string;
    currencyId: string;
    creatorId: string;
    inUseFrom: DateAsString;
    inUseTo: DateAsString;
    active: boolean;
}

export interface UpdateCurrencyCountryDto {
    countryId: string;
    currencyId: string;
    userId: string;
    inUseFrom: DateAsString;
    inUseTo: DateAsString;
    active: boolean;
}

export interface CreateCurrencyDenominationDto {
    comment: string;
    serialNumberFormat: string;
    value: number;
    currencyId: string;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    active: boolean;
    banknote: boolean;
}

export interface UpdateCurrencyDenominationDto {
    currencyDenominationId: string;
    comment: string;
    serialNumberFormat: string;
    value: number;
    currencyId: string;
    userId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    active: boolean;
    banknote: boolean;
}

export interface CreateCurrencyFormatDto {
    name: string;
    creatorId: string;
    validFrom: DateAsString;
}

export interface WebUUIDResponse {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface UpdateCurrencyFormatDto {
    currencyFormatId: string;
    name: string;
    userId: string;
    validFrom: DateAsString;
}

export interface CreateCurrencyTypeDto {
    name: string;
    creatorId: string;
    validFrom: DateAsString;
}

export interface UpdateCurrencyTypeDto {
    currencyTypeId: string;
    name: string;
    userId: string;
    validFrom: DateAsString;
}

export interface CreatePaymentCodeDto {
    code: string;
    purpose: string;
    description: string;
    forCash: boolean;
    applicableForIndividualsAndCashPayment: boolean;
    paymentCodeGroupId: string;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    active: boolean;
}

export interface CreatePaymentCodeGroupDto {
    name: string;
    description: string;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    active: boolean;
}

export interface UpdatePaymentCodeDto {
    id: string;
    code: string;
    purpose: string;
    description: string;
    forCash: boolean;
    applicableForIndividualsAndCashPayment: boolean;
    paymentCodeGroupId: string;
    userId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    active: boolean;
}

export interface UpdatePaymentCodeGroupDto {
    id: string;
    name: string;
    description: string;
    userId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    active: boolean;
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface MasterAgentApplicationDto extends PlatformApplicationDto {
    accessId: string;
    code3: string;
    active: boolean;
    providerApplication: boolean;
    groupId: string;
    secretKey: string;
}

export interface MasterAgentApplicationGroupDto {
    id: string;
    name: string;
    description: string;
    applicationType: PlatformApplicationTypeEnum;
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface PlatformApplicationDto {
    id: string;
    code6: string;
    name: string;
    description: string;
    applicationType: PlatformApplicationTypeEnum;
    status: PlatformApplicationStatusEnum;
    userStatus: PlatformApplicationUserEnum;
    loginType: PlatformApplicationLoginTypeEnum;
    registrationType: PlatformApplicationRegistrationTypeEnum;
    services: string[];
    subServices: string[];
}

export interface CurrencyDto {
    id: string;
    isoName: string;
    localName: string;
    localCode: string;
    isoAlpha3: string;
    isoNumeric: string;
    symbol: string;
    precision: number;
    currencyFormat: CurrencyFormatDto;
    currencyType: CurrencyTypeDto;
    createdAt: DateAsString;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    lastUpdatedAt: DateAsString;
    lastUpdatedBy: string;
    platformServiceCode: string;
    active: boolean;
}

export interface PaginationRequestCommonDto {
    currentPage: number;
    itemsPerPage: number;
}

export interface WebPageResponseEntity<T> extends WebResponseEntity<GetPagingResponseDto<T>> {
    body: WebResponseObject<GetPagingResponseDto<T>>;
}

export interface CurrencyPageFiltersDto {
    isoNames: string[];
    localNames: string[];
    localCodes: string[];
    isoAlpha3s: string[];
    isoNumerics: string[];
}

export interface FilterRequest extends Serializable {
    key: string;
    operator: Operator;
    field_type: FieldType;
    value: any;
    value_to: any;
    values: any[];
}

export interface SortRequest extends Serializable {
    key: string;
    direction: SortDirection;
}

export interface Serializable {
}

export interface Page<T> extends Slice<T> {
    totalPages: number;
    totalElements: number;
}

export interface CurrencyCountryDto {
    currency: CurrencyDto;
    countryId: string;
    inUseFrom: DateAsString;
    inUseTo: DateAsString;
    createdAt: DateAsString;
    creatorId: string;
    lastUpdatedAt: DateAsString;
    lastUpdatedBy: string;
    active: boolean;
}

export interface CurrencyDenominationDto {
    id: string;
    comment: string;
    serialNumberFormat: string;
    value: number;
    currency: CurrencyDto;
    createdAt: DateAsString;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    lastUpdatedAt: DateAsString;
    lastUpdatedBy: string;
    banknote: boolean;
    active: boolean;
}

export interface CurrencyFormatDto {
    id: string;
    name: string;
    createdAt: DateAsString;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    lastUpdatedAt: DateAsString;
    lastUpdatedBy: string;
    active: boolean;
}

export interface CurrencyCountryChangeDto {
    currencyIso3Name: string;
    countryIso3Name: string;
    inUseFrom: DateAsString;
    inUseTo: DateAsString;
    changes: ChangeObjectDto[];
    active: boolean;
    new: boolean;
}

export interface CurrencyChangeDto extends CurrencyDto {
    changes: ChangeObjectDto[];
    new: boolean;
}

export interface UpdateCurrencyChangeDto {
    id: string;
    isoName: string;
    localName: string;
    localCode: string;
    isoAlpha3: string;
    isoNumeric: string;
    symbol: string;
    precision: number;
    validFrom: DateAsString;
    validTo: DateAsString;
    active: boolean;
    platformServiceCode: string;
    new: boolean;
}

export interface UpdateCurrencyCountryChangeDto {
    currencyIso3Name: string;
    countryIso3Name: string;
    inUseFrom: DateAsString;
    inUseTo: DateAsString;
    active: boolean;
    new: boolean;
}

export interface CurrencyTypeDto {
    id: string;
    name: string;
    createdAt: DateAsString;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    lastUpdatedAt: DateAsString;
    lastUpdatedBy: string;
    active: boolean;
}

export interface PaymentCodeDto {
    id: string;
    code: string;
    purpose: string;
    description: string;
    applicableForIndividualsAndCashPayment: boolean;
    forCash: boolean;
    paymentCodeGroup: PaymentCodeGroupDto;
    createdAt: DateAsString;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    lastUpdatedAt: DateAsString;
    lastUpdatedBy: string;
    active: boolean;
}

export interface PaymentCodeGroupDto {
    id: string;
    name: string;
    description: string;
    createdAt: DateAsString;
    creatorId: string;
    validFrom: DateAsString;
    validTo: DateAsString;
    lastUpdatedAt: DateAsString;
    lastUpdatedBy: string;
    active: boolean;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface GetPagingResponseDto<T> {
    list: T[];
    totalCount: number;
}

export interface Sort extends Streamable<Order>, Serializable {
    sorted: boolean;
    unsorted: boolean;
}

export interface Pageable {
    offset: number;
    sort: Sort;
    paged: boolean;
    unpaged: boolean;
    pageNumber: number;
    pageSize: number;
}

export interface ChangeObjectDto {
    key: string;
    value: any;
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface Slice<T> extends Streamable<T> {
    size: number;
    content: T[];
    number: number;
    sort: Sort;
    last: boolean;
    first: boolean;
    numberOfElements: number;
    pageable: Pageable;
}

export interface Streamable<T> extends Iterable<T>, Supplier<Stream<T>> {
    empty: boolean;
}

export interface Order extends Serializable {
    direction: Direction;
    property: string;
    ignoreCase: boolean;
    nullHandling: NullHandling;
    ascending: boolean;
    descending: boolean;
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface Iterable<T> {
}

export interface Supplier<T> {
}

export interface Stream<T> extends BaseStream<T, Stream<T>> {
}

export interface BaseStream<T, S> extends AutoCloseable {
    parallel: boolean;
}

export interface AutoCloseable {
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP GET /ma-general-data/application/application
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.getMasterAgentApplication
     */
    getMasterAgentApplication(queryParams: { appId: string; }, options?: O): RestResponse<WebResponseEntity<MasterAgentApplicationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/application/application`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/application/application-languages
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.getMasterAgentApplicationLanguage
     */
    getMasterAgentApplicationLanguage(queryParams: { appId: string; }, options?: O): RestResponse<WebListResponseEntity<string>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/application/application-languages`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /ma-general-data/application/application-languages
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.setMasterAgentApplicationLanguage
     */
    setMasterAgentApplicationLanguage(request: SetMasterAgentApplicationLanguagesRequest, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/application/application-languages`, data: request, options: options });
    }

    /**
     * HTTP GET /ma-general-data/application/application-secret-key
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.getMasterAgentApplicationSecret
     */
    getMasterAgentApplicationSecret(queryParams: { appId: string; }, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/application/application-secret-key`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/application/applications
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.getMasterAgentApplicationLists
     */
    getMasterAgentApplicationLists(options?: O): RestResponse<WebListResponseEntity<MasterAgentApplicationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/application/applications`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/application/create-app
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.createApplication
     */
    createApplication(req: CreateMasterAgentApplicationRequest, options?: O): RestResponse<WebResponseEntity<MasterAgentApplicationDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/application/create-app`, data: req, options: options });
    }

    /**
     * HTTP POST /ma-general-data/application/create-app-group
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.createApplicationGroup
     */
    createApplicationGroup(req: CreateMasterAgentApplicationGroupRequest, options?: O): RestResponse<WebResponseEntity<MasterAgentApplicationGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/application/create-app-group`, data: req, options: options });
    }

    /**
     * HTTP GET /ma-general-data/application/groups
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.getMasterAgentApplicationGroupLists
     */
    getMasterAgentApplicationGroupLists(options?: O): RestResponse<WebListResponseEntity<MasterAgentApplicationGroupDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/application/groups`, options: options });
    }

    /**
     * HTTP GET /ma-general-data/application/platform-application-languages
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.getPlatformApplicationLanguage
     */
    getPlatformApplicationLanguage(queryParams: { appId: string; }, options?: O): RestResponse<WebListResponseEntity<string>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/application/platform-application-languages`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/application/platform-applications
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.getPlatformApplicationLists
     */
    getPlatformApplicationLists(options?: O): RestResponse<WebListResponseEntity<PlatformApplicationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/application/platform-applications`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/application/update-app
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.updateApplication
     */
    updateApplication(req: UpdateMasterAgentApplicationRequest, options?: O): RestResponse<WebResponseEntity<MasterAgentApplicationDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/application/update-app`, data: req, options: options });
    }

    /**
     * HTTP POST /ma-general-data/application/update-app-group
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.updateApplicationGroup
     */
    updateApplicationGroup(req: UpdateMasterAgentApplicationGroupRequest, options?: O): RestResponse<WebResponseEntity<MasterAgentApplicationGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/application/update-app-group`, data: req, options: options });
    }

    /**
     * HTTP POST /ma-general-data/application/update-app-secret
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.ApplicationDefinitionController.updateApplicationSecret
     */
    updateApplicationSecret(req: UpdateMasterAgentApplicationRequest, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/application/update-app-secret`, data: req, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency-country/create
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyCountryController.createCurrencyCountry
     */
    createCurrencyCountry(req: CreateCurrencyCountryDto, options?: O): RestResponse<WebResponseEntity<CurrencyCountryDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency-country/create`, data: req, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-country/get-all
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyCountryController.getAllCurrencyCountries
     */
    getAllCurrencyCountries(queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyCountryDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-country/get-all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-country/get-all-by-country-id/{countryId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyCountryController.getAllCurrencyCountriesByCountryId
     */
    getAllCurrencyCountriesByCountryId(countryId: string, queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyCountryDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-country/get-all-by-country-id/${countryId}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-country/get-all-by-currency-id/{currencyId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyCountryController.getAllCurrencyCountriesByCurrencyId
     */
    getAllCurrencyCountriesByCurrencyId(currencyId: string, queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyCountryDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-country/get-all-by-currency-id/${currencyId}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-country/get/{currencyId}/{countryId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyCountryController.getCurrencyCountry
     */
    getCurrencyCountry(currencyId: string, countryId: string, options?: O): RestResponse<WebResponseEntity<CurrencyCountryDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-country/get/${currencyId}/${countryId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency-country/update
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyCountryController.updateCurrencyCountry
     */
    updateCurrencyCountry(req: UpdateCurrencyCountryDto, options?: O): RestResponse<WebResponseEntity<CurrencyCountryDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency-country/update`, data: req, options: options });
    }

    /**
     * HTTP DELETE /ma-general-data/currency-country/{currencyId}/{countryId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyCountryController.deleteCurrencyCountry
     */
    deleteCurrencyCountry(currencyId: string, countryId: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`ma-general-data/currency-country/${currencyId}/${countryId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency-denomination/create
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyDenominationController.createCurrencyDenomination
     */
    createCurrencyDenomination(req: CreateCurrencyDenominationDto, options?: O): RestResponse<WebResponseEntity<CurrencyDenominationDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency-denomination/create`, data: req, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-denomination/get-by-currency-id/{currencyId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyDenominationController.getCurrencyDenominationsByCurrencyId
     */
    getCurrencyDenominationsByCurrencyId(currencyId: string, queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyDenominationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-denomination/get-by-currency-id/${currencyId}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-denomination/get/{currencyDenominationId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyDenominationController.getCurrencyDenomination
     */
    getCurrencyDenomination(currencyDenominationId: string, options?: O): RestResponse<WebResponseEntity<CurrencyDenominationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-denomination/get/${currencyDenominationId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency-denomination/update
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyDenominationController.updateCurrencyDenomination
     */
    updateCurrencyDenomination(req: UpdateCurrencyDenominationDto, options?: O): RestResponse<WebResponseEntity<CurrencyDenominationDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency-denomination/update`, data: req, options: options });
    }

    /**
     * HTTP DELETE /ma-general-data/currency-denomination/{currencyDenominationId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyDenominationController.deleteCurrencyDenomination
     */
    deleteCurrencyDenomination(currencyDenominationId: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`ma-general-data/currency-denomination/${currencyDenominationId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency-format/create
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyFormatController.createCurrencyFormat
     */
    createCurrencyFormat(req: CreateCurrencyFormatDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency-format/create`, data: req, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-format/get-all
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyFormatController.getAllCurrencyFormats
     */
    getAllCurrencyFormats(queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyFormatDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-format/get-all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-format/get/{currencyFormatId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyFormatController.getCurrencyFormat
     */
    getCurrencyFormat(currencyFormatId: string, options?: O): RestResponse<WebResponseEntity<CurrencyFormatDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-format/get/${currencyFormatId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency-format/update
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyFormatController.updateCurrencyFormat
     */
    updateCurrencyFormat(req: UpdateCurrencyFormatDto, options?: O): RestResponse<WebResponseEntity<CurrencyFormatDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency-format/update`, data: req, options: options });
    }

    /**
     * HTTP DELETE /ma-general-data/currency-format/{currencyFormatId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyFormatController.deleteCurrencyFormat
     */
    deleteCurrencyFormat(currencyFormatId: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`ma-general-data/currency-format/${currencyFormatId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency-type/create
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyTypeController.createCurrencyType
     */
    createCurrencyType(req: CreateCurrencyTypeDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency-type/create`, data: req, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-type/get-all
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyTypeController.getAllCurrencyTypes
     */
    getAllCurrencyTypes(queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyTypeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-type/get-all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency-type/get/{currencyTypeId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyTypeController.getCurrencyType
     */
    getCurrencyType(currencyTypeId: string, options?: O): RestResponse<WebResponseEntity<CurrencyTypeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency-type/get/${currencyTypeId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency-type/update
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyTypeController.updateCurrencyType
     */
    updateCurrencyType(req: UpdateCurrencyTypeDto, options?: O): RestResponse<WebResponseEntity<CurrencyTypeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency-type/update`, data: req, options: options });
    }

    /**
     * HTTP DELETE /ma-general-data/currency-type/{currencyTypeId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyTypeController.deleteCurrencyType
     */
    deleteCurrencyType(currencyTypeId: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`ma-general-data/currency-type/${currencyTypeId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency/create
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.createCurrency
     */
    createCurrency(req: CreateCurrencyDto, options?: O): RestResponse<WebResponseEntity<CurrencyDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency/create`, data: req, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency/get-all
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.getAllCurrencies
     */
    getAllCurrencies(queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency/get-all`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency/get-all-by-currency-format-and-type/currencyFormatId/{currencyFormatId}/currencyTypeId/{currencyTypeId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.getAllCurrencyByCurrencyFormat
     */
    getAllCurrencyByCurrencyFormat$GET$ma_general_data_currency_getallbycurrencyformatandtype_currencyFormatId_currencyFormatId_currencyTypeId_currencyTypeId(currencyFormatId: string, currencyTypeId: string, queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency/get-all-by-currency-format-and-type/currencyFormatId/${currencyFormatId}/currencyTypeId/${currencyTypeId}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency/get-all-by-currency-format/{currencyFormatId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.getAllCurrencyByCurrencyFormat
     */
    getAllCurrencyByCurrencyFormat$GET$ma_general_data_currency_getallbycurrencyformat_currencyFormatId(currencyFormatId: string, queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency/get-all-by-currency-format/${currencyFormatId}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency/get-all-by-currency-type/{currencyTypeId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.getAllCurrencyByCurrencyType
     */
    getAllCurrencyByCurrencyType(currencyTypeId: string, queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<CurrencyDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency/get-all-by-currency-type/${currencyTypeId}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency/get-currency-country-list-difference
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyListDifferenceController.getCurrencyCountryListDifference
     */
    getCurrencyCountryListDifference(options?: O): RestResponse<WebListResponseEntity<CurrencyCountryChangeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency/get-currency-country-list-difference`, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency/get-currency-list-difference
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyListDifferenceController.getCurrencyListDifference
     */
    getCurrencyListDifference(options?: O): RestResponse<WebListResponseEntity<CurrencyChangeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency/get-currency-list-difference`, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency/get-currency-page-filter
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.getCurrencyPageFilters
     */
    getCurrencyPageFilters(queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebResponseObject<CurrencyPageFiltersDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency/get-currency-page-filter`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency/get-page
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.getCurrencyPage
     */
    getCurrencyPage(req: GetFilteredCurrencyPageDto, options?: O): RestResponse<WebPageResponseEntity<CurrencyDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency/get-page`, data: req, options: options });
    }

    /**
     * HTTP GET /ma-general-data/currency/get/{currencyId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.getCurrency
     */
    getCurrency(currencyId: string, options?: O): RestResponse<WebResponseEntity<CurrencyDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/currency/get/${currencyId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency/save-currency-country-list-changes
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyListDifferenceController.saveCurrencyCountryChanges
     */
    saveCurrencyCountryChanges(changes: UpdateCurrencyCountryChangeDto[], options?: O): RestResponse<WebListResponseEntity<CurrencyCountryDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency/save-currency-country-list-changes`, data: changes, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency/save-currency-list-changes
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyListDifferenceController.saveCurrencyChanges
     */
    saveCurrencyChanges(currencyChanges: UpdateCurrencyChangeDto[], options?: O): RestResponse<WebListResponseEntity<CurrencyDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency/save-currency-list-changes`, data: currencyChanges, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency/save-platform-provider-currency-country-list
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyListDifferenceController.savePlatformProviderCurrencyCountryList
     */
    savePlatformProviderCurrencyCountryList(options?: O): RestResponse<WebResponseObject<number>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency/save-platform-provider-currency-country-list`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency/search
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.search
     */
    search(request: SearchRequest, options?: O): RestResponse<Page<CurrencyDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency/search`, data: request, options: options });
    }

    /**
     * HTTP POST /ma-general-data/currency/update
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.updateCurrency
     */
    updateCurrency(req: UpdateCurrencyDto, options?: O): RestResponse<WebResponseEntity<CurrencyDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/currency/update`, data: req, options: options });
    }

    /**
     * HTTP DELETE /ma-general-data/currency/{currencyId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.CurrencyController.deleteCurrency
     */
    deleteCurrency(currencyId: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`ma-general-data/currency/${currencyId}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/payment-code/create-code
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.createPaymentCode
     */
    createPaymentCode(req: CreatePaymentCodeDto, options?: O): RestResponse<WebResponseEntity<PaymentCodeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/payment-code/create-code`, data: req, options: options });
    }

    /**
     * HTTP POST /ma-general-data/payment-code/create-group
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.createPaymentCodeGroup
     */
    createPaymentCodeGroup(req: CreatePaymentCodeGroupDto, options?: O): RestResponse<WebResponseEntity<PaymentCodeGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/payment-code/create-group`, data: req, options: options });
    }

    /**
     * HTTP DELETE /ma-general-data/payment-code/delete-code/{paymentCodeId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.deletePaymentCode
     */
    deletePaymentCode(paymentCodeId: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`ma-general-data/payment-code/delete-code/${paymentCodeId}`, options: options });
    }

    /**
     * HTTP DELETE /ma-general-data/payment-code/delete-group/{id}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.deletePaymentCodeGroupById
     */
    deletePaymentCodeGroupById(id: string, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`ma-general-data/payment-code/delete-group/${id}`, options: options });
    }

    /**
     * HTTP GET /ma-general-data/payment-code/get-all-codes
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.getAllPaymentCodes
     */
    getAllPaymentCodes(queryParams?: { onlyActive?: boolean; }, options?: O): RestResponse<WebListResponseEntity<PaymentCodeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/payment-code/get-all-codes`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/payment-code/get-all-groups
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.getAllPaymentCodeGroups
     */
    getAllPaymentCodeGroups(queryParams: { onlyActive: boolean; }, options?: O): RestResponse<WebListResponseEntity<PaymentCodeGroupDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/payment-code/get-all-groups`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /ma-general-data/payment-code/get-code-by-code/{code}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.getPaymentCodeByCode
     */
    getPaymentCodeByCode(code: string, options?: O): RestResponse<WebResponseEntity<PaymentCodeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/payment-code/get-code-by-code/${code}`, options: options });
    }

    /**
     * HTTP GET /ma-general-data/payment-code/get-code-by-id/{id}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.getPaymentCodeById
     */
    getPaymentCodeById(id: string, options?: O): RestResponse<WebResponseEntity<PaymentCodeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/payment-code/get-code-by-id/${id}`, options: options });
    }

    /**
     * HTTP GET /ma-general-data/payment-code/get-codes-by-group-id/{groupId}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.getPaymentCodesByGroupId
     */
    getPaymentCodesByGroupId(groupId: string, options?: O): RestResponse<WebListResponseEntity<PaymentCodeDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/payment-code/get-codes-by-group-id/${groupId}`, options: options });
    }

    /**
     * HTTP GET /ma-general-data/payment-code/get-group-by-id/{id}
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.getPaymentCodeGroupById
     */
    getPaymentCodeGroupById(id: string, options?: O): RestResponse<WebResponseEntity<PaymentCodeGroupDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`ma-general-data/payment-code/get-group-by-id/${id}`, options: options });
    }

    /**
     * HTTP POST /ma-general-data/payment-code/update-code
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.updatePaymentCode
     */
    updatePaymentCode(req: UpdatePaymentCodeDto, options?: O): RestResponse<WebResponseEntity<PaymentCodeDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/payment-code/update-code`, data: req, options: options });
    }

    /**
     * HTTP POST /ma-general-data/payment-code/update-group
     * Java method: com.europoint.masteragentgeneraldata.web.controllers.PaymentCodeController.updatePaymentCodeGroup
     */
    updatePaymentCodeGroup(req: UpdatePaymentCodeGroupDto, options?: O): RestResponse<WebResponseEntity<PaymentCodeGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`ma-general-data/payment-code/update-group`, data: req, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

export const enum PlatformApplicationTypeEnum {
    Undefined = "Undefined",
    PlatformProviderConsole = "PlatformProviderConsole",
    MasterAgentConsole = "MasterAgentConsole",
    MasterAgentService = "MasterAgentService",
    WebMasterAgent = "WebMasterAgent",
    AgentConsole = "AgentConsole",
    AgentService = "AgentService",
    WebAgent = "WebAgent",
    MerchantConsole = "MerchantConsole",
    MerchantService = "MerchantService",
    WebMerchant = "WebMerchant",
}

export const enum PlatformApplicationStatusEnum {
    New = "New",
    Active = "Active",
    Inactive = "Inactive",
    Obsolite = "Obsolite",
}

export const enum PlatformApplicationUserEnum {
    OpenToUse = "OpenToUse",
    AppRegistrationRequired = "AppRegistrationRequired",
    AppRegistrationGrantingRequired = "AppRegistrationGrantingRequired",
    CaseVerificationRequired = "CaseVerificationRequired",
    CaseVerificationGrantingRequired = "CaseVerificationGrantingRequired",
    GroupRegistrationRequired = "GroupRegistrationRequired",
    GroupRegistrationGrantingRequired = "GroupRegistrationGrantingRequired",
    GroupCaseVerificationRequired = "GroupCaseVerificationRequired",
    GroupCaseVerificationGrantingRequired = "GroupCaseVerificationGrantingRequired",
}

export const enum PlatformApplicationLoginTypeEnum {
    Simple = "Simple",
    WithOTP = "WithOTP",
    WithCertificate = "WithCertificate",
    WithVPN = "WithVPN",
    WithCertificateOrVPN = "WithCertificateOrVPN",
    WithOtpOrVPN = "WithOtpOrVPN",
    WithCertificateOrOtp = "WithCertificateOrOtp",
    WithCertificateOrOtpOrVPN = "WithCertificateOrOtpOrVPN",
}

export const enum PlatformApplicationRegistrationTypeEnum {
    Disabled = "Disabled",
    SelfRegistration = "SelfRegistration",
    SelfRegistrationWithOtp = "SelfRegistrationWithOtp",
    AdminRegistration = "AdminRegistration",
    ApplicationRegistration = "ApplicationRegistration",
}

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum Operator {
    EQUAL = "EQUAL",
    NOT_EQUAL = "NOT_EQUAL",
    LIKE = "LIKE",
    NOT_LIKE = "NOT_LIKE",
    STARTS_WITH = "STARTS_WITH",
    END_WITH = "END_WITH",
    IN = "IN",
    NOT_IN = "NOT_IN",
    GREATER_THAN = "GREATER_THAN",
    GREATER_OR_EQUAL_TO = "GREATER_OR_EQUAL_TO",
    LESS_THAN = "LESS_THAN",
    LESS_OR_EQUAL_TO = "LESS_OR_EQUAL_TO",
    BETWEEN = "BETWEEN",
}

export const enum FieldType {
    BOOLEAN = "BOOLEAN",
    CHAR = "CHAR",
    DATE = "DATE",
    INSTANT = "INSTANT",
    DOUBLE = "DOUBLE",
    INTEGER = "INTEGER",
    LONG = "LONG",
    STRING = "STRING",
    UUID = "UUID",
    ENUM_STRING = "ENUM_STRING",
}

export const enum SortDirection {
    ASC = "ASC",
    DESC = "DESC",
}

export const enum Direction {
    ASC = "ASC",
    DESC = "DESC",
}

export const enum NullHandling {
    NATIVE = "NATIVE",
    NULLS_FIRST = "NULLS_FIRST",
    NULLS_LAST = "NULLS_LAST",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
